import { TipoDocumentoPertencer } from 'helpers/enums/TipoArquivoPertencer';
import { del, delBff, get, post, postBff, put, putBff } from './methods';

export interface DocumentoRequestUpdate {
  descricao: string;
  flgDisponivelAssociado: boolean;
  oidDocumento: number;
  idEvento: string;
}

export interface DocumentoRequestUpload {
  arquivo: string;
  descricao: string;
  flgDisponivelAssociado: boolean;
  nome: string;
  oidEvento: number;
  tamanho: number;
  tipo: TipoDocumentoPertencer;
}

const documentos = {
  download: (idDocumento: number) => {
    return get<ArrayBuffer>(`documento/${idDocumento}/download`, {
      responseType: 'arraybuffer',
    });
  },
  update: (data: DocumentoRequestUpdate) => put('documento/edit', data),
  updateBff: (data: DocumentoRequestUpdate) => putBff('document/edit', data),
  remove: (idEvento: string, idDocumento: number) =>
    del(`documento/${idEvento}/${idDocumento}`),
  removeBff: (idEvento: string, idDocumento: number) =>
    delBff(`document/${idEvento}/${idDocumento}`),
  upload: (data: DocumentoRequestUpload) => post('documento/upload', data),
  uploadBff: (data: DocumentoRequestUpload) => postBff('document/upload', data),
};

export default documentos;
